require('./mortgageRequestErrorView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { ContentBox } = require('commonsComponents/contentBox');
// @ components
const MortgageRequestError = require('components/mortgageRequest/mortgageRequestError/mortgageRequestError');
// @ constants
const { COMMONS } = require('constants/mortgageRequestHolderData');


class MortgageRequestErrorView extends React.Component {
    render() {
        const query = new URLSearchParams(this.props.location.search);
        const loansLink = '/myprofile/loans-mortgages';

        const mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: loansLink
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage'
            }
        ];

        return (
            <div className="mortgage-request-error-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('mortgageRequestPresentation-title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                <ContentBox>
                                    <MortgageRequestError
                                        phoneNumber={COMMONS.PRESTAMOS_PHONE}
                                        query={query}
                                    />
                                </ContentBox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestErrorView.propTypes = {
    immLoans: PropTypes.object,
    location: PropTypes.object
};

module.exports.constructor = MortgageRequestErrorView;

module.exports.MortgageRequestErrorView = connect(
    state => ({
        immLoans: state.loans
    }),
    {}
)(MortgageRequestErrorView);
